// ===========================================================================
// High Cost — utilidades de formato.
// ===========================================================================

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const USD_CENTS = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Formatea un monto en USD sin decimales (uso general en listas/KPIs). */
export const formatCurrency = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return USD.format(Number(value));
};

/** Formatea un monto en USD con 2 decimales (desgloses precisos). */
export const formatCurrencyCents = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return USD_CENTS.format(Number(value));
};

/** Abrevia montos grandes: 1_250_000 → "$1.25M", 48_250 → "$48.3K". */
export const formatCompactCurrency = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const n = Number(value);
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return USD.format(n);
};

/** Porcentaje con 1 decimal: 62.45 → "62.5%". El backend ya manda el número. */
export const formatPercent = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${Number(value).toFixed(1)}%`;
};

/** Fecha ISO → "MMM d, yyyy". Devuelve "—" si no hay valor. */
export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};
